module.exports = __webpack_public_path__ + "img/AL.e0d7499b.svg";